import {
    getScorerRubricBands,
    SPROUT_JUDGE_SCORER_ID,
} from '@fruitful/llm-service-shared';

export interface RubricBracketTally {
    minPercent: number;
    maxPercent: number;
    summary: string;
    count: number;
}

/** Counts judge scores into the published rubric brackets. */
export const tallyJudgeRubric = (
    scores: readonly number[],
): RubricBracketTally[] => {
    const bands = getScorerRubricBands(SPROUT_JUDGE_SCORER_ID) ?? [];
    const tallies = bands.map((band) => ({
        minPercent: band.minPercent,
        maxPercent: band.maxPercent,
        summary: band.summary,
        count: 0,
    }));

    for (const score of scores) {
        const percent = Math.round(score * 100);
        const band = tallies.find(
            (item) => percent >= item.minPercent && percent <= item.maxPercent,
        );
        if (band != null) {
            band.count += 1;
        }
    }

    return tallies;
};

/** Cases with no numeric judge score. Distinct from a published band label. */
export const UNSCORED_BRACKET_KEY = 'not-scored';

export const rubricBracketLabel = (band: {
    minPercent: number;
    maxPercent: number;
}): string => `${String(band.minPercent)}–${String(band.maxPercent)}`;

export const rubricBandColor = (minPercent: number): string => {
    if (minPercent >= 70) {
        return '$green1100';
    }
    if (minPercent >= 40) {
        return '$orange1100';
    }
    return '$red1100';
};

export const rubricCountColor = (band: RubricBracketTally): string =>
    band.count === 0 ? '$gray1000' : rubricBandColor(band.minPercent);
